/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DomainInputs */



/**
* | output |
* | --- |
* | "Domain" |
*
* @param {DomainInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const domain = /** @type {((inputs?: DomainInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DomainInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Domaine")
	if (locale === "de") return /** @type {LocalizedString} */ ("Domain")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dominio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Домен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dominio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("领域")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ドメイン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्षेत्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Domínio")
	return /** @type {LocalizedString} */ ("Domain")
});